import React from 'react';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';

export function TextAlignLeft(props: any) {
  const color = props.active ? '#2B8DFF' : '#edeeef';

  return <FormatAlignLeftIcon htmlColor={color} />;
}
